// ThemeContext.js
import React, { createContext, useState, useEffect } from "react";
import { ThemeProvider as MuiThemeProvider, createTheme, CssBaseline } from "@mui/material";

export const ThemeContext = createContext();

const getCssVar = (name) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim();

const buildMuiTheme = () => {
  const bg = getCssVar('--bg-body') || '#f3f4f6';
  const text = getCssVar('--text-color') || '#000000';
  const mode = (bg?.trim().toLowerCase() === '#f3f4f6') ? 'light' : 'dark';
  return createTheme({
    palette: {
      mode,
      background: {
        default: bg,
      },
      text: {
        primary: text,
      },
    },
    typography: {
      fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif',
    },
  });
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  const [muiTheme, setMuiTheme] = useState(buildMuiTheme());

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);
    setMuiTheme(buildMuiTheme());
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
    setMuiTheme(buildMuiTheme());
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};
